import I18n from 'I18n';
import { useContext } from 'react';
import ViewContainerContext from '../../../containers/ViewContainerContext';
import ViewToolbarAddLogo from './ViewToolbarAddLogo';
import { jsx as _jsx } from "react/jsx-runtime";
const ViewToolbarLogo = ({
  logoUrl,
  companyName,
  logoAltText
}) => {
  const context = useContext(ViewContainerContext);
  let alt = logoAltText;
  if (!logoAltText) {
    if (companyName) {
      alt = I18n.text('a11y.brandingAltText', {
        companyName
      });
    } else {
      alt = I18n.text('a11y.brandingAltTextNoCompany');
    }
  }
  if (logoUrl) {
    return /*#__PURE__*/_jsx("div", {
      role: "banner",
      "aria-labelledby": "logo-landmark",
      children: /*#__PURE__*/_jsx("img", {
        id: "logo-landmark",
        src: logoUrl,
        style: {
          maxHeight: 40
        },
        alt: alt || undefined
      })
    });
  }
  if (context.isPreview) {
    return /*#__PURE__*/_jsx(ViewToolbarAddLogo, {});
  }
  return /*#__PURE__*/_jsx("div", {});
};
export default ViewToolbarLogo;